import Tags from './tags';

export default Tags;
